
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';

export const SchoolSettingsHeader = () => {
  return (
    <div className="mb-8">
      <div className="bg-secondary text-white border-0 rounded-lg p-6" style={{ backgroundColor: '#11a7a2' }}>
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-bold text-white flex items-center gap-2">
            <Settings className="h-6 w-6" />
            إعدادات المدرسة
          </h1>
        </div>
        <p className="text-white/90 mt-2">تخصيص المراحل والصفوف ونوع تسجيل الحضور</p>
      </div>
    </div>
  );
};
